export const bannedCommentsOptions = [
  {
    value: false,
    radioValue: false,
    label: 'скрывать от меня'
  },
  {
    value: true,
    radioValue: true,
    label: 'показывать мне'
  }
];
